export * from './types';
export { HRIAClient } from './client';
export { friendlyApiMessage } from './errorMessage';
export type { FriendlyMessageOptions } from './errorMessage';
export { createAuthAPI } from './modules/auth';
export { createDonorsAPI } from './modules/donors';
export { createDonationsAPI } from './modules/donations';

import { SDKConfig } from './types';
import { HRIAClient } from './client';
import { createAuthAPI } from './modules/auth';
import { createDonorsAPI } from './modules/donors';
import { createDonationsAPI } from './modules/donations';

export const createSDK = (config: SDKConfig) => {
  const client = new HRIAClient(config);
  return {
    client,
    auth: createAuthAPI(client),
    donors: createDonorsAPI(client),
    donations: createDonationsAPI(client),
  };
};
